import { storeGetters } from "../storeGetters.constant";

const appState = {
    darkTheme: false,
};

const appMutations = {};

const appActions = {};

const appGetters = {
    [storeGetters.appTheme]: state => state.darkTheme,
};

export default {
    namespaced: true,
    state: { ...appState },
    mutations: { ...appMutations },
    actions: { ...appActions },
    getters: { ...appGetters },
};
